(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-flat"] && !Shopify.designMode) return;
  try {
    
(function(){
  function keepOpen(){
    if(!document.querySelector('.rd-flat')){return;}
    document.querySelectorAll('details[data-rd-sg]').forEach(function(d){
      d.open=true;
      d.addEventListener('toggle',function(){if(!d.open){d.open=true;}});
    });
  }
  function setupImp(){
    document.querySelectorAll('.rd-ba__impl').forEach(function(ul){
      if(ul.getAttribute('data-rd-imp')){return;}
      ul.setAttribute('data-rd-imp','1');
      var lis=ul.querySelectorAll('li');
      if(!lis.length){return;}
      var ctl=document.createElement('div');
      ctl.className='rd-imp__ctl';
      ctl.innerHTML='<span class="rd-imp__hint">Swipe or use the arrows to see every improvement</span><div class="rd-imp__arrows"><button type="button" class="rd-circle" data-dir="-1" aria-label="Previous">←</button><button type="button" class="rd-circle" data-dir="1" aria-label="Next">→</button></div>';
      var dots=document.createElement('div');
      dots.className='rd-imp__dots';
      dots.setAttribute('aria-hidden','true');
      for(var i=0;i<lis.length;i++){dots.appendChild(document.createElement('i'));}
      ul.parentNode.insertBefore(ctl,ul);
      ul.parentNode.insertBefore(dots,ul.nextSibling);
      ctl.addEventListener('click',function(e){
        var b=e.target.closest&&e.target.closest('[data-dir]');
        if(!b){return;}
        var step=lis[0].getBoundingClientRect().width+12;
        ul.scrollBy({left:step*parseInt(b.getAttribute('data-dir'),10),behavior:'smooth'});
      });
      function upd(){
        var step=lis[0].getBoundingClientRect().width+12;
        var idx=Math.round(ul.scrollLeft/step);
        if(ul.scrollLeft+ul.clientWidth>=ul.scrollWidth-4){idx=lis.length-1;}
        for(var j=0;j<dots.children.length;j++){dots.children[j].className=j===idx?'is-on':'';}
      }
      ul.addEventListener('scroll',upd,{passive:true});
      window.addEventListener('resize',upd);
      upd();
    });
  }
  function init(){keepOpen();setupImp();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-project-web"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){var t=e.target&&e.target.closest?e.target.closest('[data-rd-full]'):null;if(!t)return;var lb=document.querySelector('[data-rd-lb]');if(!lb)return;lb.classList.toggle('is-tall',t.hasAttribute('data-rd-tall'));lb.scrollTop=0;},true);
document.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.matches&&e.target.matches('[data-rd-full][role=button]')){e.preventDefault();e.target.click();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-services"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-rd-svs]');
    if(!b){return;}
    var sec=b.closest('section');
    var tr=sec&&sec.querySelector('[data-rd-svs-track]');
    if(!tr){return;}
    var card=tr.querySelector('.rd-card');
    var step=card?card.getBoundingClientRect().width+12:360;
    tr.scrollBy({left:step*parseInt(b.getAttribute('data-rd-svs'),10),behavior:'smooth'});
  });
  function setup(sec){
    var tr=sec.querySelector('[data-rd-svs-track]'),dots=sec.querySelector('[data-rd-svs-dots]');
    if(!tr||!dots){return;}
    var cards=tr.querySelectorAll('.rd-card');
    dots.innerHTML='';
    for(var i=0;i<cards.length;i++){dots.appendChild(document.createElement('i'));}
    function upd(){
      var c=cards[0];if(!c){return;}
      var step=c.getBoundingClientRect().width+12;
      var idx=Math.round(tr.scrollLeft/step);
      if(tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4){idx=cards.length-1;}
      var d=dots.children;
      for(var j=0;j<d.length;j++){d[j].className=j===idx?'is-on':'';}
    }
    tr.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    upd();
  }
  function init(){var s=document.querySelectorAll('.rd-svs');for(var i=0;i<s.length;i++){setup(s[i]);}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-svc-group"] && !Shopify.designMode) return;
  try {
    
/* Opens the matching drop-down when someone arrives from, or clicks, a link like /pages/services#serv-web */
(function(){
  if(window.__rdSg){return;}
  window.__rdSg=1;
  function openFor(id){
    if(!id){return;}
    var el=document.getElementById(id);
    var d=el&&el.querySelector?el.querySelector('details[data-rd-sg]'):null;
    if(d){d.open=true;}
  }
  function fromHash(){openFor(window.location.hash.replace('#',''));}
  window.addEventListener('hashchange',fromHash);
  document.addEventListener('DOMContentLoaded',fromHash);
  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href*="#"]'):null;
    if(!a){return;}
    var h=a.getAttribute('href')||'';
    var i=h.indexOf('#');
    if(i>-1){openFor(h.slice(i+1));}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-work-group"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__rdWg){return;}
  window.__rdWg=1;
  /* enlarge-on-click mock-ups: tall desktop screenshots open scrollable */
  document.addEventListener('click',function(e){var t=e.target&&e.target.closest?e.target.closest('[data-rd-full]'):null;if(!t){return;}var lb=document.querySelector('[data-rd-lb]');if(!lb){return;}lb.classList.toggle('is-tall',t.hasAttribute('data-rd-tall'));lb.scrollTop=0;},true);
  document.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.matches&&e.target.matches('[data-rd-full][role=button]')){e.preventDefault();e.target.click();}});
  /* hide the Scroll badge once someone scrolls that laptop screen */
  document.addEventListener('scroll',function(e){var t=e.target;if(t&&t.classList&&t.classList.contains('rd-ba__screen')&&t.parentElement){t.parentElement.classList.add('is-scrolled');}},true);
  /* open the matching drop-down for links like /pages/our-work#work-web */
  function openFor(id){if(!id){return;}var el=document.getElementById(id);var d=el&&el.querySelector?el.querySelector('details[data-rd-sg]'):null;if(d){d.open=true;}}
  function fromHash(){openFor(window.location.hash.replace('#',''));}
  window.addEventListener('hashchange',fromHash);
  document.addEventListener('DOMContentLoaded',fromHash);
  document.addEventListener('click',function(e){var a=e.target&&e.target.closest?e.target.closest('a[href*="#"]'):null;if(!a){return;}var h=a.getAttribute('href')||'';var i=h.indexOf('#');if(i>-1){openFor(h.slice(i+1));}});
})();

  } catch(e) { console.error(e); }
})();
})();
